import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { environment } from '../../environments/environment';

/**
 * Libera a tela de stub do Mercado Livre apenas nos ambientes de desenvolvimento
 * (environment.mlStub) e para quem está logado. Em produção a rota leva para /home.
 */
export const mlStubGuard: CanActivateFn = () => {
  const router = inject(Router);

  if (!environment.mlStub) {
    return router.createUrlTree(['/home']);
  }

  if (typeof window === 'undefined' || !window.localStorage) {
    return router.createUrlTree(['/login']);
  }

  const token = localStorage.getItem('jwt') || localStorage.getItem('jwt-password');
  return token ? true : router.createUrlTree(['/login']);
};
